import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ShopSlideshowActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/SlideShow/SlideShowBrowser")
	}

	render() {
		return (
			<Activity 
				name="ShopSlideshow"
				RenderedComponent={this.RenderedComponent}
				context="ShopSlideshow"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ShopSlideshowActivity)
